import { Store } from '@reduxjs/toolkit';
import { StoreType, ReducersInjectorWithState } from '@wajeez-web/stores/base';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { businessGroupState } from './businessGroup/types';
import BusinessGroupReducer from './businessGroup/slices';
import { businessGroupQuantityState } from './busineesGroupQuantity/types';
import BusinessGroupQuantityReducer from './busineesGroupQuantity/slices';
import { businessGroupsubscriptionState } from './businessGroupsubscription/types';
import BusinessGroupSubscriptionReducer from './businessGroupsubscription/slices';
import { businessGroupsUsersState } from './businessGroupUsers/types';
import BusinessGroupUsersReducer from './businessGroupUsers/slices';
export let BusinessStore: StoreType<{
  businessGroups: businessGroupState;
  businessQuantity: businessGroupQuantityState;
  businessSubscription: businessGroupsubscriptionState;
  businessGroupsUsers: businessGroupsUsersState;
}>;

// export type StoreType = typeof store;
export type BusinessDispatch = typeof BusinessStore.dispatch;
export type BusinessStoreState = ReturnType<typeof BusinessStore.getState>;
export const useBusinessDispatch = () => useDispatch<BusinessDispatch>();
export const useBusinessSelector: TypedUseSelectorHook<BusinessStoreState> =
  useSelector;
export const getBusinessState = (store: Store) =>
  store.getState() as BusinessStoreState;

export const injectBusinessReducers: ReducersInjectorWithState<
  BusinessStoreState
> = () => {
  return [
    {
      name: 'businessGroups',
      reducer: BusinessGroupReducer,
    },
    {
      name: 'businessQuantity',
      reducer: BusinessGroupQuantityReducer,
    },
    {
      name: 'businessSubscription',
      reducer: BusinessGroupSubscriptionReducer,
    },
    {
      name: 'businessGroupsUsers',
      reducer: BusinessGroupUsersReducer,
    },
  ];
};
